import useDisplayNames from '../useDisplayNames'
import pluralize from 'pluralize'

const useTppDisplayName = () => {
    const { getDisplayName } = useDisplayNames()

    const singular = getDisplayName('tpp', 'Target Product Profile')
    const plural = pluralize(singular)

    return { singular, plural }
}

export default useTppDisplayName
